// Every escalation type shares the order detail button / badge, the escalation
// modal and the EscalatedOrders panel; only what differs per team lives here.
// Keys match the escalation `type` on the backend (services/escalationService.js).

// Mirrors routes/escalations.js on the backend (mounted at /api/escalations).
const panelApi = (type) => ({
  list: `api/escalations/${type}/list`,
  count: `api/escalations/${type}/count`,
  escalate: (orderId) => `api/escalations/${type}/orders/${orderId}`,
  resolve: (escalationId) => `api/escalations/${type}/${escalationId}/resolve`,
  reopen: (escalationId) => `api/escalations/${type}/${escalationId}/reopen`,
  reply: (escalationId) => `api/escalations/${type}/${escalationId}/replies`,
});

export const ESCALATION_TYPES = {
  REFUND: {
    name: 'Cancellation / Refund',
    path: '/escalations',
    escalatePermission: 'order.escalate_refund',
    viewPermission: 'order.escalation_view',
    resolvePermission: 'order.escalation_view',
    api: panelApi('refund'),
    sidebarLabel: 'General Escalations',
    sidebarIcon: 'fa fa-undo-alt',
    title: 'Cancellation / Refund Escalations',
    badgeLabel: 'Escalated: Cancellation / Refund',
    escalateLabel: 'Escalate for Management',
    escalateDescription: 'The order will be tagged and listed on the Escalations panel for the cancellation / refund team.',
    resolveLabel: 'Resolve',
    resolveTitle: 'Resolve Escalation',
    resolvePlaceholder: 'Resolution note, e.g. refunded / cancelled on eBay (optional)',
    resolveConfirmLabel: 'Mark as Resolved',
    resolvedStatusLabel: 'RESOLVED',
    reopenTitle: 'Reopen Escalation',
  },
  PHARMACY: {
    name: 'Pharmacy',
    path: '/pharmacy-escalations',
    escalatePermission: 'order.escalate_pharmacy',
    viewPermission: 'order.pharmacy_escalation_view',
    resolvePermission: 'order.pharmacy_escalation_close',
    api: panelApi('pharmacy'),
    sidebarLabel: 'Pharmacy Escalations',
    sidebarIcon: 'fa fa-prescription-bottle-alt',
    title: 'Pharmacy Escalations',
    badgeLabel: 'Escalated: Pharmacy',
    escalateLabel: 'Escalate to Pharmacy',
    escalateDescription: 'The order will be tagged and listed on the Pharmacy Escalations panel for the pharmacy team.',
    resolveLabel: 'Close',
    resolveTitle: 'Close Pharmacy Escalation',
    resolvePlaceholder: 'Closing note, e.g. action taken by pharmacy (optional)',
    resolveConfirmLabel: 'Close Escalation',
    resolvedStatusLabel: 'CLOSED',
    reopenTitle: 'Reopen Pharmacy Escalation',
  },
};

export const ESCALATION_TYPE_KEYS = Object.keys(ESCALATION_TYPES);

// "RESOLVED" -> "Resolved", "CLOSED" -> "Closed".
export const resolvedLabelFor = ({ resolvedStatusLabel }) =>
  resolvedStatusLabel.charAt(0) + resolvedStatusLabel.slice(1).toLowerCase();

export const countReplies = (escalation) =>
  (escalation?.activity || []).filter((entry) => entry.action === 'REPLY').length;
